import React from 'react';

const Section6Astro = ({ formData, handleChange }) => (
    <div className="fade-in">
        <h4 className="mb-3">6. Astrological Details (Optional)</h4>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Date of Birth</label>
                <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Time of Birth</label>
                <input type="time" name="birthTime" value={formData.birthTime} onChange={handleChange} className="form-control" />
            </div>
        </div>
        <div className="mb-3">
            <label className="form-label">Place of Birth</label>
            <input type="text" name="birthPlace" value={formData.birthPlace} onChange={handleChange} className="form-control" />
        </div>
        <div className="mb-3">
            <label className="form-label">Manglik</label>
            <select name="manglik" value={formData.manglik} onChange={handleChange} className="form-select">
                <option>No</option>
                <option>Yes</option>
                <option>Anshik (Partial)</option>
                <option>Don't Know</option>
            </select>
        </div>
    </div>
);

export default Section6Astro;